import React, { useState } from 'react';
import styled from 'styled-components';
import NoClaimsIcon from '../../icons/NoClaimsIcon';
import { PrimaryButton } from '..';
import getConfig, { Env } from '../../config';
import { simpleGTMDataLayer } from '../../util/GTMHelpers';
import ClaimsSelectAPolicyDropdown from '../claimsSelectAPolicyDropdown';

const config = getConfig(process.env.REACT_APP_ENV as Env);

const OuterBox = styled.div`
  text-align: center;
`;

const BigBoldText = styled.p`
  font-size: 24px;
  font-weight: 700;
  margin-top: 45px;
`;

const SmallText = styled.p`
  font-size: 18px;
  margin-top: 15px;
  margin-bottom: 30px;
`;

export const NewClaimButton = styled(PrimaryButton)`
  padding: 12px 25px 12px 25px;
  display: inline;
  margin-left: auto;
  margin-right: auto;
  font-size: 18px;
  font-weight: 700;
  &:hover {
    cursor: pointer;
  }
`;

const ModalContainer = styled.div`
  position: fixed;
  margin-left: 40%;
  margin-top: 300px;
`;

const Backdrop = styled.div`
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 0.5);
`;

export interface ClaimsPageEmptyStateProps {
  UserDisplayName: string;
  /* readOnlyAccess: boolean;
  readOnlyFeatureFlag: boolean; */
}

export default ({
  UserDisplayName /* , readOnlyAccess, readOnlyFeatureFlag */
}: ClaimsPageEmptyStateProps) => {
  const [showModal, setShowModal] = useState(false);

  return (
    <OuterBox>
      <ClaimsSelectAPolicyDropdown
        showModal={showModal}
        setShowModal={setShowModal}
      />
      <NoClaimsIcon />
      <BigBoldText>No Claims Reported {UserDisplayName}</BigBoldText>
      <SmallText>Need to file a new claim?</SmallText>
      <NewClaimButton
        onClick={() => {
          simpleGTMDataLayer({
            event: 'click-claimsEmptyStartClaim'
          });
          setShowModal(true);
        }}
        // disabled={readOnlyAccess && readOnlyFeatureFlag}
      >
        START A NEW CLAIM
      </NewClaimButton>
    </OuterBox>
  );
};
